<template>
    <div class="text-center loading" :class="{ inactive: !isLoading}">
        <span class="calculating-route" :class="{ dnone: !calculatingRoute}">{{ $t("navigation.calculatingRoute") }}</span>
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div class="mapContainer" :class="{ inactive: isLoading}">
        <div id="atlasMap" ref="atlasMap" ></div>
        <MapOverlay :searchResults="searchResults" @emitMapSearch="recieveMapSearch" @setIsLoading="setIsLoading" @emitSelectedSearchResult="recieveSelectedSearchResult" @emitRegionFilter="recieveRegionFilter" @emitNewFilter="recieveNewFilter" @emitCityWalk="recieveCityWalk" @emitWalkStop="recieveWalkStop" @emitStartCityWalk="startCityWalk" />
        <div id="directions"></div>
        <div class="modal fade image-modal" id="mapModal" tabindex="-1" aria-labelledby="mapModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content">
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onclick="stopVideojs();"></button>
                    <div class="modal-body">
                        <div class="text-center loading">
                            <div class="spinner-border text-primary" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <div class="modal-media-detail" data-content-id=""></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import '../local_lib/wise-leaflet-pip.js';

import 'leaflet.markercluster';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';

import 'leaflet-routing-machine';

import 'leaflet-fullscreen';
import { LocateControl } from 'leaflet.locatecontrol';

import 'leaflet.markercluster';

import axios from 'axios';

import MapOverlay from './MapOverlay.vue'

import austria from '../geoJson/austria.json'
import states from '../geoJson/states.json'
import vienna from '../geoJson/vienna.json'

export default {
    name: "AtlasMap",
    components: {
        MapOverlay,
    },
    data() {
        var markerIcons = [];
        markerIcons['audio'] = L.icon({
            iconUrl: '/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/markerAudio.svg',
            iconSize: [38, 95], 
            popupAnchor:  [0, -25],
        });
        markerIcons['video'] = L.icon({
            iconUrl: '/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/markerVideo.svg',
            iconSize: [38, 95], 
            popupAnchor:  [0, -25],
        });
        markerIcons['stop'] = L.icon({
            iconUrl: '/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/markerStop.svg',
            iconSize: [38, 95], 
            popupAnchor:  [0, -25],
        });
        markerIcons['user'] = L.icon({
            iconUrl: '/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/markerUser.svg',
            iconSize: [38, 95], 
            popupAnchor:  [0, -25],
        });

        var exhibitionCall = "";
        if(window.location.href.indexOf("beethoven") > -1){
            exhibitionCall = '&tx_mbitatlas_getmarkers[exhibition]=beethoven';
        }
        if(window.location.href.indexOf("schoenberg") > -1){
            exhibitionCall = '&tx_mbitatlas_getmarkers[exhibition]=schoenberg';
        }

        return {
            isLoading: true,
            map: null,
            markers: [],
            markersData: [],
            polygons: [],
            markerIcons: markerIcons,
            routeControl: null,
            routeCalculated: false,
            calculatingRoute: false,
            routeProfile: 'mapbox/walking',
            userLocation: null,
            userFound: false,
            clusterAll: null,
            mapSearch: '',
            searchResults: [],
            selectedSearchResult: '',
            regionFilter: '',
            newFilter: null,
            cityWalk: null,
            walkLines: null,
            walkStop: null,
            showAll: false,
            clusterFiltered: null,
            exhibitionCall: exhibitionCall,
            activeToolTip: '',
            activeToolTipMarker: null,
            modalCache: {},
            markerMeta: {},
        };
    },
    computed: {
        routeReady: function () {
            return this.routeCalculated && this.userLocation._active && this.userFound;
        }
    },
    watch: {
        mapSearch(newValue, oldValue){
            if(newValue != oldValue){
                // Ensure map is initialized before proceeding
                if (!this.map) {
                    console.warn('Map not initialized yet, skipping search');
                    return;
                }
                
                this.endNavigation();
                window.dispatchEvent(new CustomEvent('searchLengthUpdated', { 
                    detail: newValue.length 
                }));
                if(newValue.length > 3){
                    this.showAll = false;
                    this.isLoading = true;
                    if(this.clusterFiltered){
                        this.map.removeLayer(this.clusterFiltered);
                        this.clusterFiltered = null;
                    }

                    this.clusterFiltered = L.markerClusterGroup({
                        spiderfyOnMaxZoom: false,
                        showCoverageOnHover: false,
                        animate: false,
                        animateAddingMarkers: false,
                        disableClusteringAtZoom: 8
                    });
                    
                    // Ensure clusterFiltered is properly initialized
                    if (!this.clusterFiltered) {
                        console.error('Failed to initialize clusterFiltered');
                        this.isLoading = false;
                        return;
                    }
                    
                    var self = this;
                    fetch(self.$t("apiBase") + "?type=1740552151&tx_mbitatlas_getmarkers[searchString]=" + newValue + self.exhibitionCall)
                        .then((response) => response.json())
                        .then((data) => {
                            var unorderedSearchResults = data.response.docs;
                            var titleMatch = [];
                            var descriptionMatch = [];
                            var searchString = newValue.toUpperCase();
                            unorderedSearchResults.forEach((searchResult) => {
                                if(searchResult['title'].toUpperCase().includes(searchString) || searchResult['titleExact'].toUpperCase().includes(searchString)){
                                    titleMatch.push(searchResult);
                                }
                                else{
                                    descriptionMatch.push(searchResult);
                                }
                            });
                            self.searchResults = titleMatch.concat(descriptionMatch);
                            // Dispatch custom event with search results
                            window.dispatchEvent(new CustomEvent('searchResultsUpdated', { 
                                detail: self.searchResults 
                            }));
                            if (self.markers) {
                                self.searchResults.forEach((marker) => {
                                    // Check if the marker exists before trying to add it
                                    if (self.markers[marker.uniqueIdentifier]) {
                                        self.markers[marker.uniqueIdentifier].addTo(self.clusterFiltered);
                                    }
                                });
                            } else {
                                console.warn('Markers object not initialized');
                            }
                            
                            // Only add cluster to map and fit bounds if we have search results
                            if (self.searchResults.length > 0) {
                                try {
                                    self.clusterFiltered.addTo(self.map);
                                    if(self.clusterFiltered.getBounds().isValid()){
                                        self.map.fitBounds(self.clusterFiltered.getBounds());
                                    }
                                } catch (error) {
                                    console.error('Error adding cluster to map:', error);
                                }
                            }
                            self.isLoading = false;
                        })
                        .catch((error) => {
                            console.error("Error fetching data:", error);
                        });
                }
                else{
                    this.showAll = true;
                    this.searchResults = [];
                    // Dispatch empty results
                    window.dispatchEvent(new CustomEvent('searchResultsUpdated', { 
                        detail: [] 
                    }));
                }
            }
        },
        regionFilter(newValue, oldValue){
            if(newValue){
                this.showAll = false;
                this.calculatingRoute = false;
                this.mapSearch = '';
                $('#mapSearch').val('');
                this.endNavigation();               
                
                // Reset previous filtered layer
                if(this.clusterFiltered){
                    try { this.map.removeLayer(this.clusterFiltered); } catch(e) {}
                    this.clusterFiltered = null;
                }
                this.clusterFiltered = L.markerClusterGroup({
                    spiderfyOnMaxZoom: false,
                    showCoverageOnHover: false,
                    animate: false,
                    animateAddingMarkers: false,
                    disableClusteringAtZoom: 8
                });

                let includeFn = null;
                let fitBoundsTarget = null;
                const allKeys = Object.keys(this.markers);
                const contains = (poly, latlng) => {
                    try { return poly && poly.contains && poly.contains(latlng); } catch(e) { return false; }
                };

                if(newValue == 'worldwide'){
                    fitBoundsTarget = this.clusterAll;
                    includeFn = (key) => !contains(this.polygons['austria'], this.markers[key].getLatLng());
                }
                if(newValue == 'austria'){
                    fitBoundsTarget = this.polygons['austria'];
                    includeFn = (key) => contains(this.polygons['austria'], this.markers[key].getLatLng());
                }
                if(newValue.includes('states') || newValue.includes('vienna')){
                    var region = newValue.split('-')[0];
                    var iso = parseInt(newValue.split('-')[1]);
                    fitBoundsTarget = this.polygons[region][iso];
                    // Special case carried over from previous logic: iso==3 exclude Vienna (iso 9)
                    if(region === 'states' && iso === 3){
                        includeFn = (key) => contains(this.polygons['states'][iso], this.markers[key].getLatLng()) && !contains(this.polygons['states'][9], this.markers[key].getLatLng());
                    } else {
                        includeFn = (key) => contains(this.polygons[region][iso], this.markers[key].getLatLng());
                    }
                }

                let foundOne = false;
                if(includeFn){
                    allKeys.forEach(key => {
                        if (this.markers[key] && includeFn(key)){
                            this.markers[key].addTo(this.clusterFiltered);
                            foundOne = true;
                        }
                    });
                }

                this.clusterFiltered.addTo(this.map);
                try {
                    if(foundOne && this.clusterFiltered.getBounds().isValid()){
                        this.map.fitBounds(this.clusterFiltered.getBounds());
                    } else if(fitBoundsTarget && fitBoundsTarget.getBounds && fitBoundsTarget.getBounds().isValid()){
                        this.map.fitBounds(fitBoundsTarget.getBounds());
                    }
                } catch(e) {}

                this.regionFilter = null;
            }
        },
        newFilter(newValue, oldValue){
            if(newValue){
                this.endNavigation();
                this.showAll = true;
                this.mapSearch = '';
                $('#mapSearch').val('');
                this.panTo(this.markers[newValue].getLatLng());
                this.bindTooltipForMarkerId(newValue, this.markers[newValue]);
                // Open tooltip right away after panning for new filter
                const markerNF = this.markers[newValue];
                if (markerNF && typeof markerNF.fire === 'function') {
                    const isMobile = window.innerWidth <= 991.98;
                    setTimeout(() => {
                        markerNF.fire(isMobile ? 'click' : 'mouseover');
                    }, 150);
                }
                this.newFilter = null;
            }
        },
        selectedSearchResult(newValue, oldValue){
            if(newValue){
                this.panTo(this.markers[newValue].getLatLng());
                this.bindTooltipForMarkerId(newValue, this.markers[newValue]);
                this.selectedSearchResult = null;
            }
        },
        walkStop(newValue, oldValue){ 
            if(this.cityWalk && this.cityWalk.stops[newValue].latitude){
                this.panTo([this.cityWalk.stops[newValue].latitude, this.cityWalk.stops[newValue].longitude]);
                // Open tooltip right away after panning
                const stop = this.cityWalk.stops[newValue];
                const markerId = stop.unique_identifier || (this.cityWalk.uid + '_' + newValue);
                const marker = this.markers[markerId];
                if (marker) {
                    const isMobile = window.innerWidth <= 991.98;
                    setTimeout(() => {
                        if (isMobile) {
                            // Manually bind tooltip for mobile
                            // Clear any existing tooltip from other markers
                            if(this.activeToolTip != '' && this.activeToolTip != markerId){
                                var activeMarker = this.markers[this.activeToolTip];
                                if(activeMarker && activeMarker.unbindTooltip){
                                    if(activeMarker._hideTimeout) {
                                        clearTimeout(activeMarker._hideTimeout);
                                        activeMarker._hideTimeout = null;
                                    }
                                    activeMarker.unbindTooltip();
                                }
                                else if(this.activeToolTipMarker && this.activeToolTipMarker.unbindTooltip){
                                    if(this.activeToolTipMarker._hideTimeout) {
                                        clearTimeout(this.activeToolTipMarker._hideTimeout);
                                        this.activeToolTipMarker._hideTimeout = null;
                                    }
                                    this.activeToolTipMarker.unbindTooltip();
                                }
                                this.activeToolTip = '';
                                this.activeToolTipMarker = null;
                            }

                            this.activeToolTip = markerId;
                            this.activeToolTipMarker = marker;

                            const meta = this.getMetaFromStop(stop);
                            // Prefetch modal so play starts immediately after tap
                            this.prefetchModal(meta.uniqueIdentifier);
                            marker.bindTooltip(
                                this.buildTooltipHTML(meta),
                                {
                                    permanent: true,
                                    interactive: true,
                                    direction: 'top',
                                    opacity: 1,
                                    offset: [0, -25],
                                }
                            );
                        } else if (typeof marker.fire === 'function') {
                            // Desktop: use mouseover to open tooltip
                            marker.fire('mouseover');
                        }
                    }, 150);
                }
            }
        },
        cityWalk(newValue, oldValue){
            if(newValue != oldValue){
                this.endNavigation();
                if(newValue == null){
                    this.showAll = true;
                }
                else{
                    this.isLoading = true;
                    this.calculatingRoute = false;
                    this.showAll = false;
                    if(this.walkLines){
                        if(this.clusterFiltered){
                            this.clusterFiltered.removeLayer(this.walkLines);
                        }
                        this.walkLines = null;
                    }
                    if(this.clusterFiltered){
                        this.map.removeLayer(this.clusterFiltered);
                        this.clusterFiltered = null;
                    }

                    this.clusterFiltered = L.markerClusterGroup({
                        spiderfyOnMaxZoom: false,
                        showCoverageOnHover: false,
                        animate: false,
                        animateAddingMarkers: false,
                        disableClusteringAtZoom: 8
                    });

                    var Waypoints = [];
                    var self = this;
                    newValue.stops.forEach((stop, index) => {
                        // Validate coordinates before creating waypoint
                        if(!stop.latitude || !stop.longitude || isNaN(parseFloat(stop.latitude)) || isNaN(parseFloat(stop.longitude))){
                            console.warn('Invalid coordinates for stop:', stop);
                            return; // Skip this stop
                        }
                        
                        // Add existing marker to filtered cluster if it has a unique identifier
                        if (stop.unique_identifier && this.markers[stop.unique_identifier]) {
                            this.markers[stop.unique_identifier].addTo(this.clusterFiltered);
                        }
                        
                        // Add waypoint for routing
                        try {
                            var waypoint = new L.Routing.Waypoint(L.latLng(stop.latitude, stop.longitude), index, {allowUTurn: true});
                            Waypoints[index] = waypoint;
                        } catch (error) {
                            console.error('Error creating waypoint for stop:', stop, error);
                        }
                    });
                    
                    // Only proceed with routing if we have valid waypoints
                    if(Waypoints.length > 0 && Waypoints.some(wp => wp !== undefined)){
                        var routingMachiene = L.Routing.mapbox(
                        'pk.eyJ1IjoibWJpdC1zb2x1dGlvbnMiLCJhIjoiY21jOTdnbjQ3MTFwdDJrczM2dTY3Y254cyJ9.Mn7v1iNKFtW0NE2E4l2oIw',
                        {
                            profile: this.routeProfile,
                            alternatives: false,
                            language: this.$t("langCode"),
                        });
                        routingMachiene.route(Waypoints, function(errors, results){
                            self.isLoading = false;
                            if(results && results[0]){
                                self.walkLines = L.Routing.line(results[0]);
                                self.walkLines.addTo(self.clusterFiltered);
                            } else {
                                console.warn('No routing results found for waypoints:', Waypoints);
                                self.isLoading = false;
                            }
                        });
                    } else {
                        console.warn('No valid waypoints found for routing');
                        this.isLoading = false;
                    }

                    this.clusterFiltered.addTo(this.map);
                    if(this.clusterFiltered.getBounds().isValid()){
                        this.map.fitBounds(this.clusterFiltered.getBounds());
                    }
                }
            }
        },
        routeReady(newValue, oldValue){
            if(newValue && !oldValue){
                this.isLoading = false;
                this.routeCalculated = false;
                this.userfound = false;
            }
        },
        showAll(newValue, oldValue){
            if(newValue != oldValue){
                if(newValue == true){
                    if(this.clusterFiltered){
                        this.map.removeLayer(this.clusterFiltered);
                        this.clusterFiltered = null;
                    }
                    this.clusterAll.addTo(this.map);
                }
                else{
                    this.map.removeLayer(this.clusterAll);
                }
            }
        },
    },
    methods: {
        openModal(uniqueIdentifier){
            // Open modal without autoplay - for normal marker clicks
            $("#mapModal").modal("show");
            const $modal = $("#mapModal");
            const cached = this.modalCache && this.modalCache[uniqueIdentifier];
            if($modal.find(".modal-media-detail").data("content-id") != uniqueIdentifier){
                $modal.find(".loading").removeClass("hide");
                $modal.find(".modal-media-detail").addClass("hide");
                $modal.find(".modal-media-detail").data("content-id", uniqueIdentifier);
                $modal.find(".modal-media-detail").empty();
                if (cached) {
                    $modal.find(".modal-media-detail").append(cached);
                    $modal.find(".loading").addClass("hide");
                    $modal.find(".modal-media-detail").removeClass("hide");
                } else {
                    axios.get(AtlasMap.$t("apiBase") + "?type=1740552152&tx_mbitatlas_mediadetail%5BuniqueIdentifier%5D=" + uniqueIdentifier)
                    .then((response) => {
                        $modal.find(".modal-media-detail").append(response.data);
                        // cache HTML
                        try { AtlasMap.modalCache[uniqueIdentifier] = response.data; } catch(e) {}
                        $modal.find(".loading").addClass("hide");
                        $modal.find(".modal-media-detail").removeClass("hide");
                    })
                    .catch((error) => {
                        console.error("Error fetching data:", error);
                    });
                }
            }
            // Clear any active tooltip when opening modal
            this.clearActiveTooltip();
        },
        openModalAndPlay(uniqueIdentifier){
            // Open modal, load content if necessary, then start playback like the popup button
            $("#mapModal").modal("show");
            const $modal = $("#mapModal");
            const cached = this.modalCache && this.modalCache[uniqueIdentifier];
            if($modal.find(".modal-media-detail").data("content-id") != uniqueIdentifier){
                $modal.find(".loading").removeClass("hide");
                $modal.find(".modal-media-detail").addClass("hide");
                $modal.find(".modal-media-detail").data("content-id", uniqueIdentifier);
                $modal.find(".modal-media-detail").empty();
                if (cached) {
                    $modal.find(".modal-media-detail").append(cached);
                    $modal.find(".loading").addClass("hide");
                    $modal.find(".modal-media-detail").removeClass("hide");
                    // Add delay to ensure DOM is fully rendered and media players are initialized
                    setTimeout(() => {
                        AtlasMap.playMediaInModal(uniqueIdentifier);
                        try { $('#collapse-modal-player').collapse('show'); } catch(e) {}
                    }, 300);
                } else {
                    axios.get(AtlasMap.$t("apiBase") + "?type=1740552152&tx_mbitatlas_mediadetail%5BuniqueIdentifier%5D=" + uniqueIdentifier)
                    .then((response) => {
                        $modal.find(".modal-media-detail").append(response.data);
                        // cache HTML
                        try { AtlasMap.modalCache[uniqueIdentifier] = response.data; } catch(e) {}
                        $modal.find(".loading").addClass("hide");
                        $modal.find(".modal-media-detail").removeClass("hide");
                        // Add delay to ensure DOM is fully rendered and media players are initialized
                        setTimeout(() => {
                            // Start playback after content is rendered and players are initialized
                            AtlasMap.playMediaInModal(uniqueIdentifier);
                            // Ensure audio section expands if audio
                            try { $('#collapse-modal-player').collapse('show'); } catch(e) {}
                        }, 300);
                    })
                    .catch((error) => {
                        console.error("Error fetching data:", error);
                    });
                }
            } else {
                // Add delay to ensure DOM is fully rendered and media players are initialized
                setTimeout(() => {
                    AtlasMap.playMediaInModal(uniqueIdentifier);
                    try { $('#collapse-modal-player').collapse('show'); } catch(e) {}
                }, 300);
            }
            // Clear any active tooltip when opening modal
            this.clearActiveTooltip();
        },
        prefetchModal(uniqueIdentifier){
            if(!uniqueIdentifier) { return; }
            if(this.modalCache && this.modalCache[uniqueIdentifier]) { return; }
            axios.get(this.$t("apiBase") + "?type=1740552152&tx_mbitatlas_mediadetail%5BuniqueIdentifier%5D=" + uniqueIdentifier)
            .then((response) => {
                try { this.modalCache[uniqueIdentifier] = response.data; } catch(e) {}
            })
            .catch(() => {});
        },
        playMediaInModal(uniqueIdentifier){
            const marker = this.markers && this.markers[uniqueIdentifier] ? this.markers[uniqueIdentifier] : null;
            const type = marker && marker.titleType ? marker.titleType : null;
            const isMobile = window.innerWidth <= 991.98;
            // Always stop any other player first for a clean start
            try { if (typeof stopVideojs === 'function') { stopVideojs(); } } catch(e) {}

            // Prefer using in-modal play buttons wired by the template for immediate start
            const tryClickPlayButton = () => {
                try {
                    const $modal = $('#mapModal');
                    
                    // For audio, always try audio player first
                    if (type === 'audio') {
                        let $btn = $modal.find('.player-play-button[data-player="player_one-modal-player"]');
                        if ($btn && $btn.length) { $btn.first()[0].click(); return true; }
                    }
                    
                    // For video, choose the correct player based on viewport and what exists
                    if (type === 'video') {
                        // Check which video players actually exist in the modal
                        const desktopPlayerExists = $modal.find('#player_video_desktop-modal-player').length > 0;
                        const mobilePlayerExists = $modal.find('#player_video_mobile-modal-player').length > 0;
                        
                        if (isMobile && mobilePlayerExists) {
                            // Mobile viewport, use mobile player
                            let $btn = $modal.find('.player-play-button[data-player="player_video_mobile-modal-player"]');
                            if ($btn && $btn.length) { $btn.first()[0].click(); return true; }
                        } else if (!isMobile && desktopPlayerExists) {
                            // Desktop viewport, use desktop player
                            let $btn = $modal.find('.player-play-button[data-player="player_video_desktop-modal-player"]');
                            if ($btn && $btn.length) { $btn.first()[0].click(); return true; }
                        } else {
                            // Fallback: try whichever player exists
                            let $btn = $modal.find('.player-play-button[data-player="player_video_desktop-modal-player"]');
                            if ($btn && $btn.length) { $btn.first()[0].click(); return true; }
                            $btn = $modal.find('.player-play-button[data-player="player_video_mobile-modal-player"]');
                            if ($btn && $btn.length) { $btn.first()[0].click(); return true; }
                        }
                    }
                } catch(e) {}
                return false;
            };

            const tryDirectPlay = () => {
                try {
                    if (window.videojs) {
                        // For audio, try audio player first
                        if (type === 'audio') {
                            if (document.getElementById('player_one-modal-player')) {
                                const p = window.videojs('player_one-modal-player');
                                if (p) { p.play(); return true; }
                            }
                        }
                        
                        // For video, choose the correct player based on viewport and what exists
                        if (type === 'video') {
                            const desktopPlayerExists = document.getElementById('player_video_desktop-modal-player');
                            const mobilePlayerExists = document.getElementById('player_video_mobile-modal-player');
                            
                            if (isMobile && mobilePlayerExists) {
                                // Mobile viewport, use mobile player
                                const p = window.videojs('player_video_mobile-modal-player');
                                if (p) { p.play(); return true; }
                            } else if (!isMobile && desktopPlayerExists) {
                                // Desktop viewport, use desktop player
                                const p = window.videojs('player_video_desktop-modal-player');
                                if (p) { p.play(); return true; }
                            } else {
                                // Fallback: try whichever player exists
                                if (desktopPlayerExists) {
                                    const p = window.videojs('player_video_desktop-modal-player');
                                    if (p) { p.play(); return true; }
                                }
                                if (mobilePlayerExists) {
                                    const p = window.videojs('player_video_mobile-modal-player');
                                    if (p) { p.play(); return true; }
                                }
                            }
                        }
                    }
                } catch(e) {}
                return false;
            };

            // Expand audio section if relevant
            if(type === 'audio'){
                try { $('#collapse-modal-player').collapse('show'); } catch(e) {}
            }

            // Attempt immediate button click; if not ready, wait briefly and retry, then fallback to direct play
            let attempts = 0;
            const maxAttempts = 10;
            const tick = () => {
                attempts++;
                if (tryClickPlayButton()) { return; }
                if (attempts >= maxAttempts) { tryDirectPlay(); return; }
                setTimeout(tick, 80);
            };
            tick();
        },
        waitForVideoJS(playerId, onReady, onTimeout){
            const maxAttempts = 30; // ~3s at 100ms
            let attempts = 0;
            const timer = setInterval(function(){
                attempts++;
                try {
                    if(window.videojs && (videojs.getPlayers()[playerId] || document.getElementById(playerId))){
                        let player = videojs.getPlayers()[playerId] || videojs(playerId);
                        if(player){
                            clearInterval(timer);
                            onReady && onReady(player);
                            return;
                        }
                    }
                } catch(e){}
                if(attempts >= maxAttempts){
                    clearInterval(timer);
                    onTimeout && onTimeout();
                }
            }, 100);
        },
        clearActiveTooltip() {
            if(this.activeToolTipMarker && this.activeToolTipMarker.unbindTooltip) {
                // Clear the timeout if it exists
                if(this.activeToolTipMarker._hideTimeout) {
                    clearTimeout(this.activeToolTipMarker._hideTimeout);
                    this.activeToolTipMarker._hideTimeout = null;
                }
                this.activeToolTipMarker.unbindTooltip();
            }
            this.activeToolTip = '';
            this.activeToolTipMarker = null;
        },
        
        // Add this method to handle route button clicks
        handleRouteClick(lat, lng) {
            this.navigateTo(lat, lng);
        },
        
        navigateTo(lat, lng) {
            if (navigator.geolocation) {
                if (typeof stopVideojs === "function") { 
                    stopVideojs();
                }
                this.isLoading = true;
                this.calculatingRoute = true;
                var self = this;
                navigator.geolocation.getCurrentPosition(function (position) {
                    if(AtlasMap.clusterFiltered){
                        AtlasMap.map.removeLayer(AtlasMap.clusterFiltered);
                        AtlasMap.clusterFiltered = null;
                    }
                    var userLatLng = L.latLng(position.coords.latitude, position.coords.longitude);
                    var targetLatLng = L.latLng(lat, lng);
                    AtlasMap.clusterFiltered = L.markerClusterGroup({
                        spiderfyOnMaxZoom: false,
                        showCoverageOnHover: false,
                        animate: false,
                        animateAddingMarkers: false,
                        disableClusteringAtZoom: 1
                    });
                    var Startmarker = L.marker(
                        userLatLng, 
                        {icon: AtlasMap.markerIcons['user']}
                    ).addTo(AtlasMap.clusterFiltered);
                    Startmarker.bindTooltip(
                        AtlasMap.$t("navigation.yourLocation"),
                        {
                            permanent: false, 
                            interactive: false, 
                            direction: 'top',
                            opacity: 1,
                            offset: [0, -25],
                        });
                    AtlasMap.clusterFiltered.addTo(AtlasMap.map);
                    AtlasMap.calculateRoute([userLatLng, targetLatLng], "{name}");
                }, function (error) {
                    self.isLoading = false;
                    alert("Standort konnte nicht abgerufen werden. Bitte den Standortzugriff erlauben.");
                });
            } else {
                alert("Geolocation wird von Ihrem Browser nicht unterstützt.");
            }
        },
        calculateRoute(routeWaypoints, title) {

            this.showAll = false;
            this.endNavigation();
            if(routeWaypoints.length == 2){
                var navigate = 'AtlasMap.navigateTo(' + routeWaypoints[1].lat + ', ' + routeWaypoints[1].lng + ');';
            }
            else{
                var navigate = 'AtlasMap.startCityWalk();';
            }
            this.routeControl = L.Routing.control({
                waypoints: routeWaypoints,
                router: new L.Routing.mapbox(
                    'pk.eyJ1IjoibWJpdC1zb2x1dGlvbnMiLCJhIjoiY21jOTdnbjQ3MTFwdDJrczM2dTY3Y254cyJ9.Mn7v1iNKFtW0NE2E4l2oIw',
                    {
                        profile: this.routeProfile,
                        alternatives: false,
                        language: this.$t("langCode"),
                    }),
                draggableWaypoints: false,
                routeWhileDragging: false,
                useZoomParameter: false,
                showAlternatives: false,
                createMarker: function () {
                    return null;
                },
                lineOptions : {
                    addWaypoints: false
                },
                summaryTemplate: "<div class='profile-switcher " + this.routeProfile.split('/')[1] + "'><button title='" + this.$t("controls.routeWalking") + "' class='profile-walking' onclick=\"AtlasMap.switchProfile('mapbox/walking'); " + navigate + "\"><img src='/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/person-walking-solid.svg' /></button><button title='" + this.$t("controls.routeCycling") + "' class='profile-bike' onclick=\"AtlasMap.switchProfile('mapbox/cycling'); " + navigate + "\"><img src='/_assets/fb7bab206c65e9eae4f23be4d841b727/JavaScript/Atlas/src/assets/bicycle-solid.svg' /></button></div><h2>" + title + "</h2><button type=\"button\" class=\"btn-close\" onclick=\"AtlasMap.endNavigation();$('.cityWalkContainer .btn-close').click();AtlasMap.showAll=true;\"></button><h3>{distance}, {time}</h3>"
            }).addTo(this.map);
            if(this.userLocation._active){
                this.userLocation.stop();
            }
            this.userLocation.start();
            
            // Div für Anweisungen
            var directionsDiv = document.getElementById('directions');

            var self = this;

            // Event: Wenn eine Route gefunden wird
            this.routeControl.on('routesfound', function (e) {
                // var routes = e.routes[0];
                // var routeInstructions = []; // Leere Anweisungen-Liste
                // directionsDiv.innerHTML = ""; // Vorherigen Inhalt löschen

                // Schritte hinzufügen und Koordinaten speichern
                // routes.instructions.forEach((step, index) => {
                //     var stepDiv = document.createElement('div');
                //     stepDiv.className = 'step';
                //     stepDiv.id = `step-${index}`;
                //     stepDiv.innerHTML = `${step.text}`;
                //     directionsDiv.appendChild(stepDiv);

                //     // Schritt und zugehörige Koordinaten speichern
                //     routeInstructions.push({
                //         text: step.text,
                //         lat: routes.coordinates[step.index].lat,
                //         lng: routes.coordinates[step.index].lng
                //     });
                // });
                self.routeCalculated = true;
            });

            // Event: Fehler beim Routing
            this.routeControl.on('routingerror', function () {
                self.routeCalculated = true;
                alert("Es ist ein Fehler beim Berechnen der Route aufgetreten. Bitte versuchen Sie es erneut.");
            });

            
        },
        startCityWalk(){
            if (navigator.geolocation) {
                this.isLoading = true;
                this.calculatingRoute = true;
                var self = this;
                if(this.walkLines){
                    if(this.clusterFiltered){
                        this.clusterFiltered.removeLayer(this.walkLines);
                    }
                    this.walkLines = null;
                }
                
                navigator.geolocation.getCurrentPosition(function (position) {
                    var LatLngs = [];
                    LatLngs[0] = L.latLng(position.coords.latitude, position.coords.longitude);

                    var Startmarker = L.marker(
                        LatLngs[0], 
                        {icon: AtlasMap.markerIcons['user']}
                    ).addTo(AtlasMap.clusterFiltered);
                    Startmarker.bindTooltip(
                        AtlasMap.$t("navigation.yourLocation"),
                        {
                            permanent: false, 
                            interactive: false, 
                            direction: 'top',
                            opacity: 1,
                            offset: [0, -25],
                        });
                    AtlasMap.cityWalk.stops.forEach((stop, index) => {
                        LatLngs[index + 1] = L.latLng(stop.latitude, stop.longitude);
                    });

                    AtlasMap.calculateRoute(LatLngs, AtlasMap.cityWalk.title);
                }, function (error) {
                    self.isLoading = false;
                    alert("Standort konnte nicht abgerufen werden. Bitte den Standortzugriff erlauben.");
                });
            } else {

                alert("Geolocation wird von Ihrem Browser nicht unterstützt.");
            }
        },
        endNavigation(){
            if (this.routeControl) {
                this.map.removeControl(this.routeControl);   
                this.routeControl = null;
            }
        },
        switchProfile(profile){
            if(this.routeProfile != profile){
                this.routeProfile = profile;
            }
        },
        panTo(LatLng){
            this.map.setView(LatLng, 18, {
                "animate": true,
                "pan": {
                    "duration": 1.5
                }
            });
        },
        recieveMapSearch(mapSearch){
            this.mapSearch = mapSearch;
        },
        recieveRegionFilter(regionFilter){
            this.regionFilter = regionFilter;
        },
        recieveNewFilter(newFilter){
            this.newFilter = newFilter;
        },
        recieveSelectedSearchResult(selectedSearchResult){
            this.selectedSearchResult = selectedSearchResult;
        },
        recieveWalkStop(walkStop){
            this.walkStop = walkStop;
            
            // On mobile, fold in the walk description when a walk stop is clicked
            const isMobile = window.innerWidth <= 991.98;
            if (isMobile) {
                // Add the folded-in class to collapse the walk description
                $('.cityWalkContainer').addClass('folded-in');
            }
        },
        recieveCityWalk(cityWalk){
            this.cityWalk = cityWalk;
        },
        setIsLoading(newIsLoading){
            this.isLoading = newIsLoading;
        },
        buildTooltipHTML(meta){
            const listenLabel = (window.location.href.includes('/en/')
                ? (meta.titleType === 'audio' ? 'Listen' : 'Play now')
                : (meta.titleType === 'audio' ? 'Reinhören' : 'Jetzt abspielen'));
            const canListen = meta.uniqueIdentifier && (meta.titleType === 'audio' || meta.titleType === 'video');
            return (
                '<p class="tooltip-title">' + (meta.title || '') + '</p>' +
                '<p class="tooltip-address">' + (meta.address || '') + '</p>' +
                '<div class="tooltip-buttons">' +
                '<a class="route-button" role="button" href="#" onclick="AtlasMap.navigateTo(' + meta.latitude + ', ' + meta.longitude + '); return false;"><span>Route</span></a>' +
                (canListen ? ' <a class="route-button listen-button" role="button" href="#" onclick="console.log(\'Tooltip button clicked\'); AtlasMap.openModalAndPlay(\'' + meta.uniqueIdentifier + '\'); return false;"><span>' + listenLabel + '</span></a>' : '') +
                '</div>'
            );
        },
        getMetaFromStop(stop){
            let title = stop.title || (stop.dabis_data ? stop.dabis_data.title : '');
            let address = '';
            let latitude = stop.latitude;
            let longitude = stop.longitude;
            let titleType = stop.dabis_data ? stop.dabis_data.titleType : undefined;
            const uniqueIdentifier = stop.unique_identifier || null;
            if(uniqueIdentifier && this.markers[uniqueIdentifier]){
                const markerData = this.markers[uniqueIdentifier];
                if(markerData.relationPlaces && markerData.relationPlaces[0]){
                    const p = markerData.relationPlaces[0];
                    if(p.place_postalcode && p.place_country && p.place_street){
                        address += p.place_postalcode + ' ' + p.place_country + ', ' + p.place_street;
                    }
                    latitude = parseFloat(p.place_latitude);
                    longitude = parseFloat(p.place_longitude);
                }
                title = markerData.title;
                titleType = markerData.titleType || titleType;
            }
            return { title, address, latitude, longitude, titleType, uniqueIdentifier };
        },
        getMetaFromMarkerById(uniqueIdentifier){
            // Prefer precomputed meta
            const meta = this.markerMeta && this.markerMeta[uniqueIdentifier];
            if (meta) { return meta; }
            // Fallback to extracting from marker instance
            const m = this.markers[uniqueIdentifier];
            let address = '';
            let latitude = 0;
            let longitude = 0;
            if (m && m.relationPlaces && m.relationPlaces[0]){
                const p = m.relationPlaces[0];
                if(p.place_postalcode && p.place_country && p.place_street){
                    address = p.place_postalcode + ' ' + p.place_country + ', ' + p.place_street;
                }
                latitude = parseFloat(p.place_latitude);
                longitude = parseFloat(p.place_longitude);
            }
            return {
                title: m ? m.title : '',
                address,
                latitude,
                longitude,
                titleType: m ? m.titleType : undefined,
                uniqueIdentifier
            };
        },
        bindTooltipForMarkerId(uniqueIdentifier, markerObj){
            // Clear others
            if(this.activeToolTip != '' && this.activeToolTip != uniqueIdentifier){
                const activeMarker = this.markers[this.activeToolTip];
                if(activeMarker && activeMarker.unbindTooltip){
                    if(activeMarker._hideTimeout) {
                        clearTimeout(activeMarker._hideTimeout);
                        activeMarker._hideTimeout = null;
                    }
                    activeMarker.unbindTooltip();
                } else if(this.activeToolTipMarker && this.activeToolTipMarker.unbindTooltip){
                    if(this.activeToolTipMarker._hideTimeout) {
                        clearTimeout(this.activeToolTipMarker._hideTimeout);
                        this.activeToolTipMarker._hideTimeout = null;
                    }
                    this.activeToolTipMarker.unbindTooltip();
                }
                this.activeToolTip = '';
                this.activeToolTipMarker = null;
            }

            const meta = this.getMetaFromMarkerById(uniqueIdentifier);
            if (!markerObj) { return; }
            
            // Check if tooltip already exists for this marker
            if (markerObj._tooltip) {
                // Tooltip already exists, just update active state
                this.activeToolTip = uniqueIdentifier;
                this.activeToolTipMarker = markerObj;
                return;
            }
            
            // Create new tooltip only if it doesn't exist
            this.activeToolTip = uniqueIdentifier;
            this.activeToolTipMarker = markerObj;
            markerObj.bindTooltip(
                this.buildTooltipHTML(meta),
                {
                    permanent: true,
                    interactive: true,
                    direction: 'top',
                    opacity: 1,
                    offset: [0, -25],
                }
            );
            // Auto hide after 5s
            let hideTimeout = setTimeout(() => {
                if(markerObj._tooltip){
                    this.activeToolTip = '';
                    markerObj.unbindTooltip();
                }
            }, 5000);
            markerObj._hideTimeout = hideTimeout;
        },
    },
    mounted() {
        this.polygons['austria'] = L.polygon(austria.features[0].geometry.coordinates[0]);
        this.polygons['states'] = [];
        this.polygons['vienna'] = [];

        states.features.forEach((feature) => {
            this.polygons['states'][feature.properties.iso] = L.polygon(feature.geometry.coordinates[0]);
        });
        vienna.features.forEach((feature) =>    {
            this.polygons['vienna'][feature.properties.iso] = L.polygon(feature.geometry.coordinates[0]);
        });

        var mapOptions = {
            center: [48.214447, 16.384341],
            zoom: 12,
            zoomControl: false,
            fullscreenControl: false,
            bounds: null,
        };

        this.map = L.map("atlasMap", mapOptions);
        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 18,
            attribution: '© OpenStreetMap contributors',
        }).addTo(this.map);

        L.control.zoom({
            position: 'topright',
            zoomInTitle: this.$t("controls.zoomIn"),
            zoomOutTitle: this.$t("controls.zoomOut"),
        }).addTo(this.map);

        // Always stop media when modal closes (any close method)
        try {
            $('#mapModal').off('hide.bs.modal.atlasStop').on('hide.bs.modal.atlasStop', function(){
                try { if (typeof stopVideojs === 'function') { stopVideojs(); } } catch(e) {}
            });
        } catch(e) {}
        
        this.userLocation = new LocateControl({
            position: 'topright',
            strings: {
                title: this.$t("controls.showLocation")
            },
            keepCurrentZoomLevel: true
        });
        this.userLocation.addTo(this.map);
        var self = this;
        this.map.on("locationfound", function (event) {
            self.userFound = true;
        });

        if (document.fullscreenEnabled) { 
            L.control.fullscreen({
                position: 'topright',
                title: {
                    'false': this.$t("controls.viewFullscreen"),
                    'true': this.$t("controls.exitFullscreen")
                },
                forcePseudoFullscreen: false
            }).addTo(this.map);
        }

        
        this.clusterAll = L.markerClusterGroup({
            spiderfyOnMaxZoom: false,
            showCoverageOnHover: false,
            animate: false,
            animateAddingMarkers: false,
            disableClusteringAtZoom: 16
        });

        fetch(this.$t("apiBase") + "?type=1740552151" + this.exhibitionCall)
            .then((response) => response.json())
            .then((data) => {
                data.response.docs.forEach((marker) => {
                    // Build marker meta once
                    const p = marker.relationPlaces && marker.relationPlaces[0] ? marker.relationPlaces[0] : null;
                    let address = '';
                    if(p && p.place_postalcode && p.place_country && p.place_street){
                        address = p.place_postalcode + ' ' + p.place_country + ', ' + p.place_street;
                    }
                    this.markerMeta[marker.uniqueIdentifier] = {
                        title: marker.title,
                        titleType: marker.titleType,
                        address,
                        latitude: p ? parseFloat(p.place_latitude) : null,
                        longitude: p ? parseFloat(p.place_longitude) : null,
                        uniqueIdentifier: marker.uniqueIdentifier,
                    };

                    this.markers[marker.uniqueIdentifier] = L.marker([parseFloat(marker.relationPlaces[0].place_latitude), parseFloat(marker.relationPlaces[0].place_longitude)], {icon: this.markerIcons[marker.titleType]}).addTo(this.clusterAll);
                    var self = this;
                    this.markers[marker.uniqueIdentifier]
                    .on('mouseover', function () {
                        // Check if this is mobile - on mobile, don't show tooltip on mouseover
                        const isMobile = window.innerWidth <= 991.98;
                        if (isMobile) {
                            return;
                        }
                        // Always clear any existing tooltip from other markers first
                        self.bindTooltipForMarkerId(marker.uniqueIdentifier, this);
                    });
                    this.markers[marker.uniqueIdentifier]
                    .on('mouseout', function () {
                        let hideTimeout = setTimeout(() => {
                            if(this._tooltip){
                                self.activeToolTip = '';
                                self.activeToolTipMarker = null; // Clear the marker reference too
                                this.unbindTooltip();
                            }
                        }, 2500);
                        // Store the timeout reference so we can clear it if needed
                        this._hideTimeout = hideTimeout;
                    });

                    this.markers[marker.uniqueIdentifier].on("click", function (event) {
                        if(event.originalEvent && event.originalEvent.target.classList.contains("leaflet-marker-icon")){
                            // Check if this is mobile
                            const isMobile = window.innerWidth <= 991.98;
                            if (isMobile) {
                                if (this._tooltip && self.activeToolTip === marker.uniqueIdentifier) {
                                    AtlasMap.openModal(marker.uniqueIdentifier);
                                } else {
                                    // First tap: show tooltip via unified helper
                                    self.bindTooltipForMarkerId(marker.uniqueIdentifier, this);
                                }
                            } else {
                                // Desktop behavior - open modal directly (no autoplay)
                                AtlasMap.openModal(marker.uniqueIdentifier);
                            }
                        }
                    });
                    this.markers[marker.uniqueIdentifier].relationPlaces = marker.relationPlaces;
                    this.markers[marker.uniqueIdentifier].title = marker.title;
                    this.markers[marker.uniqueIdentifier].titleType = marker.titleType;
                    this.markers[marker.uniqueIdentifier].uniqueIdentifier = marker.uniqueIdentifier;
                });
                this.showAll = true;

                this.isLoading = false;
                let urlParams = new URLSearchParams(window.location.search);
                if(urlParams.has('atom')){
                    var panToWhat = urlParams.get('atom');
                    if(this.markers[panToWhat]){
                        this.panTo(this.markers[panToWhat].getLatLng());
                        if(!this.markers[panToWhat]._tooltip){
                            if(this.activeToolTip != '' && this.activeToolTip != panToWhat){
                                this.markers[panToWhat].unbindTooltip();
                            }
                            this.activeToolTip = panToWhat;
                            var address = "";
                            if(this.markers[panToWhat].relationPlaces[0].place_postalcode && this.markers[panToWhat].relationPlaces[0].place_country && this.markers[panToWhat].relationPlaces[0].place_street){
                                address += this.markers[panToWhat].relationPlaces[0].place_postalcode + " " + this.markers[panToWhat].relationPlaces[0].place_country + ", " + this.markers[panToWhat].relationPlaces[0].place_street;
                            }

                            // Localized label like popup button
                            this.bindTooltipForMarkerId(panToWhat, this.markers[panToWhat]);
                            let hideTimeout = setTimeout(() => {
                                if(this.markers[panToWhat]._tooltip){
                                    this.activeToolTip = '';
                                    this.markers[panToWhat].unbindTooltip();
                                }
                            }, 5000);
                        }
                    }
                }
                // console.log(this.markers);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
                this.isLoading = false;
            });
        window.AtlasMap = this;

    }
};

</script>

<style scoped>
</style>